import material_equipment_accrual from './material-equipment-accrual';
import subcontract_accrual from './subcontract-accrual';
import {removeDefaultDates, setDefaultEvent} from '../../project-review/mprExecutiveSummary';
import textareaAutoHeight from '../../../modules/modue--textareaAutoHeight';
import _bundle from '../../../core/core--bundles';
import {openCloseWindow, windowTriggers} from '../../global/kendoWindows';

let k_quarterSelect = null;
let k_pmSelect = null;
let isDirty = false;

export default function () {
    textareaAutoHeight.add({
        element: '.form-item__autoheight'
    });
    init();

    _bundle.add({
        name: 'Accrual Page Update',
        event: ['on:PageUpdate'],
        fn() {
            attachGridEvents();
            setOverrideData();
        }
    });
    
    _bundle.add({
       name: 'Accrual UI Update',
       event: ['on:UiUpdate'], 
       fn() {
           setOverrideData();
       }
    });

    preventExitWithDirty();
}

const updateValue = (e) => {
    const ele = $(e.currentTarget);
    const checked = ele.is(':checked');
    const grid = ele.closest('.invoiceGrid').data().kendoGrid;
    const dataItem = grid.dataItem($(ele).closest('tr'));
    dataItem.Included = checked;
    dataItem.set('dirty', true);
    dataItem.dirtyFields.Included = true;
};

function applyOperator(e) {
    const newVal = e.sender.value();
    const filterMenu = $(e.sender.element[0].parentElement.parentElement);
    const opDdl = filterMenu.find('select[title="Operator"]').data('kendoDropDownList');
    if (newVal === 'Posted Prior to Year End') opDdl.value('neq');
    else opDdl.value('eq');
    opDdl.trigger('change');
}

function attachGridEvents() {
    const $invoiceGrids = $('.invoiceGrid, .js-prior-invoices');
    if ($invoiceGrids.length === undefined) return;

    $.each($invoiceGrids, function (index, ele) {
        const $self = $(ele);
        const grid = $self.data('kendoGrid');
        if (grid) {
            grid.bind('dataBound', function (event) {
                const $grid = event.sender;
                const $element = $grid.element;
                const $cells = $element.find('.updateValue');
                $cells.click(updateValue);
                $cells.click(getCheckedToAccrue);
                getCheckedToAccrue($self);
                if ($('[data-kendoWindow]').length) {
                    setAttachmentWindowData();
                    setCommentWindowData();
                    windowTriggers();
                    openCloseWindow();
                }
            });
            grid.bind('filterMenuInit', function (e) {
                if (e.field === 'Source') {
                    $(e.container).css('width', '275px');
                    e.container.find('[title="Operator"]').hide();
                    const fdd = e.container.find('input[title="Value"]').data('kendoDropDownList');
                    fdd.bind('change', applyOperator);
                }
            });
        }
    });
}

const init = () => {
    hideLoaders();
    let $quarterSelect = $('#quarter');
    if ($quarterSelect.length) k_quarterSelect = $quarterSelect.data('kendoDropDownList');
    let $pmSelect = $('#projectManager');
    if ($pmSelect.length) k_pmSelect = $pmSelect.data('kendoDropDownList');
    const $includedCells = $('.updateValue');

    if (k_quarterSelect && k_pmSelect) {
        attachQuarterEvent();
        attachProjectManagerEvent();
        runAccrualInit();
        setPriorInvoiceWindowData();
    }
};

const runAccrualInit = () => {
    if ($('[data-view="materials-equipment-accrual"]').length) material_equipment_accrual(k_quarterSelect, k_pmSelect);
    if ($('[data-view="subcontract-accrual"]').length) subcontract_accrual(k_quarterSelect, k_pmSelect);
};

export const setTitle = (tagText, setTag) => {
    const $title = $('#mainTitle');
    const $tag = $('#tagTitle');
    const $select = $('#statusSelect');
    if ($title.length) {
        if (setTag) {
            $title.addClass('t-large-xxx');
            if ($tag.length) {
                $tag.addClass('tag t-large tag--green');
                $tag.innerText = tagText;
            }
            $select.hide();
        } else {
            $title.removeClass('t-large-xxx');
            $tag.removeClass('tag t-large tag--green');
            $tag.hide();
            $select.show();
        }
    }
};

export const invoiceInit = () => {
    // Page Setup
    hideLoaders();
    setPanelBar();
    removeDefaultDates();
    setDefaultEvent();
    attachTotalUpdateEvent();

    // Page Functions
    if (!GetOverviewTotals()) getSegmentTotals();
};



const attachQuarterEvent = () => {
    if (k_quarterSelect) {
        k_quarterSelect.bind('change', function () {
            k_pmSelect.dataSource.read();
        });
    }
};

const attachProjectManagerEvent = () => {
    if (k_pmSelect) {
        k_pmSelect.dataSource.transport.parameterMap = function (data, type) {
            if (type === 'read') {
                data.qid = k_quarterSelect.value();
            }
            return data;
        };
        k_pmSelect.dataSource._events.change = k_pmSelect.dataSource._events.change || [];
        k_pmSelect.dataSource._events.change.push(function () {
        });
    }
};

const hideLoaders = () => {
    $('.js-invoice-spinner').hide();
    $('#js-accrual-filter').attr('disabled', false);
};

export const showLoaders = () => {
    $('.js-invoice-spinner').show();
    $('.js-accrual-section').html('');
    $('#js-accrual-filter').attr('disabled', true);
};

const setPanelBar = () => {
    const $soxPanel = $('.pannelbar--sox-exc');
    if ($soxPanel.length) {
        $soxPanel.kendoPanelBar({
            expandMode: 'multiple'
        });
    }
};

const attachTotalUpdateEvent = () => {
    $('input[data-segment]').on('blur', function () {
        getSegmentTotals();
    });
    $('input[id^=InterCompany]').on('change', function () {
        getSegmentTotals();
    })
};

export const getSegmentTotals = () => {
    const $invoiceAmounts = $('input[data-segment]');
    let constructionTotal = 0;
    let serviceTotal = 0;
    let IcConstructionTotal = 0;
    let IcServiceTotal = 0;
    let otherTotal = 0;

    $.each($invoiceAmounts, function (index, ele) {
        const $self = $(ele);
        let segment = $self.data('segment');
        const accrualId = $self.data('accrual-id');
        const overrideValue = Number($(`#OverrideAmount${accrualId}`).val());
        const value = (!isNaN(overrideValue) && overrideValue > 0) ? overrideValue : Number($self.val());
        const interCompany = $(`#InterCompany${accrualId}`).prop('checked');

        if (!isNaN(value)) {
            if (interCompany) segment = `IC - ${  segment}`;
            switch (segment) {
                case 'Construction': {
                    constructionTotal += value;
                    break;
                }
                case 'Service': {
                    serviceTotal += value;
                    break;
                }
                case 'IC - Construction': {
                    IcConstructionTotal += value;
                    break;
                }
                case 'IC - Service': {
                    IcServiceTotal += value;
                    break;
                }
                default: {
                    otherTotal += value;
                    break;
                }
            }
        }
    });

    $('.js-construction-total').text(kendo.toString(constructionTotal, 'c2'));
    $('.js-service-total').text(kendo.toString(serviceTotal, 'c2'));
    $('.js-ic-construction-total').text(kendo.toString(IcConstructionTotal, 'c2'));
    $('.js-ic-service-total').text(kendo.toString(IcServiceTotal, 'c2'));
    // $('.js-other-total').text(kendo.toString(otherTotal, 'c2'));
    $('.js-invoice-total').text(kendo.toString((constructionTotal + serviceTotal + IcConstructionTotal + IcServiceTotal), 'c2'));
};

const GetOverviewTotals = () => {
    const $constructionTotal = $('#ConstructionTotal');
        const $serviceTotal = $('#ServiceTotal');
        const $icConstructionTotal = $('#IcConstructionTotal');
        const $icServiceTotal = $('#IcServiceTotal');

    if ($constructionTotal.length) {
        const constructionTotal = Number($constructionTotal.val());
            const serviceTotal = Number($serviceTotal.val());
            const IcConstructionTotal = Number($icConstructionTotal.val());
            const IcServiceTotal = Number($icServiceTotal.val());

        $('.js-construction-total').text(kendo.toString(constructionTotal, 'c2'));
        $('.js-service-total').text(kendo.toString(serviceTotal, 'c2'));
        $('.js-ic-construction-total').text(kendo.toString(IcConstructionTotal, 'c2'));
        $('.js-ic-service-total').text(kendo.toString(IcServiceTotal, 'c2'));
        $('.js-invoice-total').text(kendo.toString((constructionTotal + serviceTotal + IcConstructionTotal + IcServiceTotal), 'c2'));
        return true
    }

    return false;
}

export const answerChangedEvent = () => {
    $('.js-accrual-form input, textarea').on('keydown, change', function (e) {
        $(this).parent().find('input, textarea').addClass('--changed');
        isDirty = true;
    })
}

export const clearChangeIndicator = () => {
    $('.--changed').removeClass('--changed');
    isDirty = false;
}

export const preventExitWithDirty = () => {
    window.addEventListener('beforeunload', function (e) {
        if (!isDirty) {
            return undefined;
        }

        const confirmationMessage = 'It looks like you have been editing something. '
            + 'If you leave before saving, your changes will be lost.';

        (e || window.event).returnValue = confirmationMessage; // Gecko + IE
        return confirmationMessage; // Gecko + Webkit, Safari, Chrome etc.
    });
}

export const getCheckedToAccrue = (e) => {
    let checkedToAccrue = 0;
        const $self = $(e.currentTarget || e);
        const $parent = $self.parents('form');
        const k_grid = $parent.find('.invoiceGrid').data('kendoGrid');

    if (k_grid) {
        k_grid.dataSource.data().forEach(function (element, index) {
            if (element && element.Source !== 'Posted Prior to Year End' && element.Included) {
                checkedToAccrue += Number(element.InvoiceAmount);
            }
        })

        const $checkedToAccrueResult = $parent.find('.js-checked-accrue');
        if ($checkedToAccrueResult.length) {
            $checkedToAccrueResult.text(kendo.toString(checkedToAccrue, 'n2'))
        }
    }
}

const setAttachmentWindowData = () => {
    const $attachmentModalButton = $('[data-kendoWindow="ViewpointAttachments"]:not(.bound)');

    if ($attachmentModalButton.length) {
        $attachmentModalButton.unbind('click');
        $attachmentModalButton.on('click', function () {
            const $attachmentModal = $('#ViewpointAttachments');
            const $self = $(this);
            const $form = $self.closest('form');
            const accrualId = $form.data('accrual-id');

            $attachmentModal.data('vendor', $form.find(`#SubContractorNumber${accrualId}`).val());
            $attachmentModal.data('ap-ref-number', $self.data('ap-ref-number'));
        });
    }
}


const setCommentWindowData = () => {
    const $commentBtn = $('[data-kendoWindow="invoiceComment"]');
    
    if ($commentBtn.length) {
        $commentBtn.unbind('click');
        $commentBtn.bind('click', function() {
            const commentWindow = $('#invoiceComment');
            const that = $(this);
            const windowData = that.data();
            const $form = that.closest('form');
            const accrualId = $form.data('accrual-id');
            const thirdPartyId = $form.find(`#SubContractorNumber${accrualId}`).val();
            
            if (windowData.role) delete windowData.role;
            if (windowData.kendoWindow) delete windowData.kendoWindow;
            if (accrualId.length) windowData['accrual-id'] = accrualId;
            if (thirdPartyId.length) windowData['third-party-id'] = thirdPartyId;
            windowData.qid = k_quarterSelect.value();

            commentWindow.data(windowData);
        });
    }
}

export const setOverrideData = () => {
    const $ovrBtn = $('[data-kendoWindow="AccrualBfmOverride"]');

    if ($ovrBtn.length) {
        const event = 'focus'; // isTopList ? 'focus' : 'click';
        $ovrBtn.unbind(event);
        $ovrBtn.on(event, function () {
            const win = $('#AccrualBfmOverride');
            const that = $(this);
            const windowData = that.data();
            windowData.qid = k_quarterSelect.value();
            win.data(windowData);
        });
    }
}

export const setPriorInvoiceWindowData = () => {
    let $priorInvoiceButton = $('[data-kendoWindow="PriorQuarterInvoices"]');

    if ($priorInvoiceButton.length) {
        $priorInvoiceButton.on('click', function () {
            let $priorInvoiceModal = $('#PriorQuarterInvoices'),
                $self = $(this);

            $priorInvoiceModal.data('qid', $self.data('qid'));
            $priorInvoiceModal.data('purchase-order', $self.data('purchase-order'));
            $priorInvoiceModal.data('vendor', $self.data('vendor'));
        });
    }
}